import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UpdatewifidetailsComponent } from './updatewifidetails.component';

const routes: Routes = [
    {
        path: '',
        component: UpdatewifidetailsComponent,
        data: {
            title: 'Update Wifi Details'
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class UpdatewifidetailsRoutingModule { }
